<div class="isd-picker-container" [class.disabled]="isDisabled">
    <div class="input-group">
        <div class="input-group-prepend" (click)="toggleDropdown()">
            <span class="input-group-text flag-trigger">
                <span class="dial-code">+{{ selectedCountry.dialCode }}</span>
                <span class="arrow-down">▼</span>
            </span>
        </div>
        <input type="tel" class="form-control phone-input" [placeholder]="'Enter phone number'" [disabled]="isDisabled"
            [(ngModel)]="phoneNumber" (ngModelChange)="onPhoneNumberChange($event)" [maxlength]="maxLength">
    </div>

    <div class="dropdown-menu show" *ngIf="isOpen">
        <div class="search-container">
            <input type="text" class="form-control search-input" placeholder="Search country..."
                [(ngModel)]="searchText" (ngModelChange)="filterCountries()" (click)="$event.stopPropagation()"
                autoFocus>
        </div>
        <div class="country-list">
            <div class="country-item" *ngFor="let country of filteredCountries" (click)="selectCountry(country)">
                <span class="country-name">{{ country.name }}</span>
                <span class="country-dial-code">+{{ country.dialCode }}</span>
            </div>
            <div *ngIf="filteredCountries.length === 0" class="no-results">
                No countries found
            </div>
        </div>
    </div>
</div>